import { styled } from '../../utils/styled'
import Grid from '../Grid'
import type { DrawerAnchor } from './types'

/** Horizontal/vertical padding on Frame content. Pages may break out horizontally using this value. */
export const FRAME_CONTENT_PADDING = '48px'

export const StyledFrameContainer = styled(Grid)(() => ({
  transform: 'scale(1)',
  height: '100vh'
}))
export const StyledFrame = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  height: '100%',
  backgroundColor: theme.tokens.background.main.pressed
}))

export const StyledSideNavigationContainer = styled(Grid)(({ theme }) => ({
  flex: '0 0 auto',
  zIndex: theme.zIndex.sideNav
}))

export const StyledContentContainer = styled(Grid)(({ theme }) => ({
  background: theme.tokens.background.main.default,
  flex: '1 1 auto',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '32px 0px 0px 32px',
  overflowX: 'auto'
}))

interface StyledTopNavigationProps {
  isScrolled: boolean
}

export const StyledTopNavigation = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'isScrolled'
})<StyledTopNavigationProps>(({ theme, isScrolled }) => ({
  flex: '0 0 auto',
  background: theme.tokens.background.main.default,
  borderRadius: `32px 4px 0px 4px`,
  width: '100%',
  position: 'sticky',
  zIndex: theme.zIndex.topNav,
  top: '0',
  right: '0',
  transition: 'box-shadow 0.1s ease-in-out',
  boxShadow: isScrolled ? theme.elevation.mediumDepth : 'none'
}))

interface StyledBodyProps {
  anchor: DrawerAnchor
}

const FLEX_DIRECTION_BY_ANCHOR: Record<DrawerAnchor, React.CSSProperties['flexDirection']> = {
  top: 'column-reverse',
  bottom: 'column',
  left: 'row-reverse',
  right: 'row'
}

export const StyledBody = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'anchor'
})<StyledBodyProps>(({ anchor }) => ({
  display: 'flex',
  flexDirection: FLEX_DIRECTION_BY_ANCHOR[anchor],
  overflow: 'hidden',
  flexGrow: 1
}))

interface StyledContentProps {
  contentPadding: string
}

export const StyledContent = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'contentPadding'
})<StyledContentProps>(({ contentPadding }) => ({
  padding: contentPadding,
  overflow: 'auto',
  height: '100%',
  width: '100%',
  flex: '1 1 auto',
  transition: 'flex 225ms cubic-bezier(0, 0, 0.2, 1)'
}))

export const StyledContentInner = styled(Grid)({
  minHeight: '100%',
  minWidth: '692px'
})
